"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onRouteUpdate = void 0;

var onRouteUpdate = function onRouteUpdate(_ref) {
  var location = _ref.location;

  // Don't track while developing.
  if (process.env.NODE_ENV === 'production' && typeof rdt === 'function') {
    rdt('track', 'ViewContent');
  }
};

exports.onRouteUpdate = onRouteUpdate;